var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.885,
    height: 21.9,
    viewBox: "0 0 26.885 21.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#435877;stroke:#fff;stroke-width:0.3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.431,7.323H21.113L17.79,4h-9L5.472,7.323H4.154A4.155,4.155,0,0,0,0,11.477v9.969A4.155,4.155,0,0,0,4.154,25.6H22.431a4.155,4.155,0,0,0,4.154-4.154V11.477A4.155,4.155,0,0,0,22.431,7.323Zm2.492,14.123a2.5,2.5,0,0,1-2.492,2.492H4.154a2.5,2.5,0,0,1-2.492-2.492V17.293h5.2a6.637,6.637,0,0,0,12.856,0h5.2ZM8.308,15.631a4.985,4.985,0,1,1,4.985,4.985A4.99,4.99,0,0,1,8.308,15.631Zm16.616,0H19.939a6.646,6.646,0,0,0-13.293,0H1.662V11.477A2.5,2.5,0,0,1,4.154,8.985H6.159L9.483,5.662H17.1l3.323,3.323h2.006a2.5,2.5,0,0,1,2.492,2.492Z",
    transform: "translate(0.15 -3.85)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.8311b9acde8092a5700bd924feff651b.svg";
export { ForwardRef as ReactComponent };